export const COUPON_API_BASE_URL = 'https://cs.api.travel.rakuten.co.jp';
export const COUPON_API_ENDPOINT = '/couponapi/hotel';

// Coupon domain constants
export const MEMBER_RANKS = {
  REGULAR: 1,
  SILVER: 2,
  GOLD: 3,
  PLATINUM: 4,
  DIAMOND: 5,
  UNRANKED: 0,
} as const;

export const BOOKING_HISTORY = {
  FIRST_TIME: 1,
  REPEAT_CUSTOMER: 2,
} as const;

export const SPECIAL_CODE = {
  HOMETOWN_TAX: 2,
} as const;

export const SERVICE_COUPON_GENRES = {
  PRIORITY: 1,
} as const;

export const CREDIT_CARD_ONLY = {
  YES: '1',
  NO: '0',
} as const;

// Only 2 is treated as first-time use; all other values are treated as regular
export const MEMBERSHIP_TARGET = {
  FIRST_TIME: 2,
  REGULAR: 0,
} as const;

// Type exports
export type MemberRank = (typeof MEMBER_RANKS)[keyof typeof MEMBER_RANKS];
export type BookingHistory = (typeof BOOKING_HISTORY)[keyof typeof BOOKING_HISTORY];
export type SpecialCode = (typeof SPECIAL_CODE)[keyof typeof SPECIAL_CODE];
export type ServiceCouponGenre = (typeof SERVICE_COUPON_GENRES)[keyof typeof SERVICE_COUPON_GENRES];
export type CreditCardOnly = (typeof CREDIT_CARD_ONLY)[keyof typeof CREDIT_CARD_ONLY];
export type MembershipTarget = (typeof MEMBERSHIP_TARGET)[keyof typeof MEMBERSHIP_TARGET];
